import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "Newcomers",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const { getNewcomers, getNewcomersError, getNewcomersSuccess } =
  slice.actions;

reducerRegistry.register("newcomers", reducer);
